import './ViewPromptChain.scss';

import React, { FC } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ViewPromptChainProps {}

const ViewPromptChain: FC<ViewPromptChainProps> = () => (
  <div className="ViewPromptChain">
    ViewPromptChain Component
  </div>
);

export default ViewPromptChain;
